var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: 32,
    height: 32,
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.5 37.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.74,13.86v3.02h-6.7v13.44h-3.04v-13.44h-6.72v-3.02s16.46,0,16.46,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.73,37.51h-4.57c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h3.81v-3.81c0-.42.34-.77.77-.77s.77.34.77.77v4.57c0,.42-.34.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05,37.51h-7.11c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h7.11c.42,0,.77.34.77.77s-.34.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.83,37.51h-4.56c-.42,0-.77-.34-.77-.77v-4.57c0-.42.34-.77.77-.77s.77.34.77.77v3.81h3.81c.42,0,.77.34.77.77s-.34.77-.77.77h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27,25.82c-.42,0-.77-.34-.77-.77v-7.11c0-.42.34-.77.77-.77s.77.34.77.77v7.11c0,.42-.34.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27,11.6c-.42,0-.77-.34-.77-.77v-4.56c0-.42.34-.77.77-.77h4.57c.42,0,.77.34.77.77s-.34.77-.77.77h-3.82v3.81c0,.42-.34.77-.77.77h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05,7.03h-7.11c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h7.11c.42,0,.77.34.77.77s-.34.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,11.6c-.42,0-.77-.34-.77-.77v-3.81h-3.81c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h4.57c.42,0,.77.34.77.77v4.57c0,.42-.34.77-.77.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,25.82c-.42,0-.77-.34-.77-.77v-7.11c0-.42.34-.77.77-.77s.77.34.77.77v7.11c0,.42-.34.77-.77.77Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "8 0 0 0 0 8 8 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.0d84837e7dd2fcdd8deba3afbce1d3d6.svg";
export { ForwardRef as ReactComponent };